module.exports = __webpack_public_path__ + "img/维修.77e6468c.png";